import { CellText } from "assets/js/Styles";
import React from "react";

export const columns = [
  {
    name: "",
    selector: null,
    sortable: false,
    id: "highlight",
    width: "5px",
    cell: () => null,
  },
  {
    name: "Name",
    selector: (row) => row?.fullName,
    grow: 2,
    sortable: true,
    minWidth: "130px",
    style: { cursor: "pointer" },
    cell: ({ fullName }) => <CellText>{fullName}</CellText>,
  },
  {
    name: "District",
    selector: (row) => row?.District,
    grow: 2,
    minWidth: "120px",
    sortable: true,
    style: { cursor: "pointer" },
    cell: ({ District }) => <CellText>{District?.name}</CellText>,
  },
];
